import { getEnv } from "./env";
import { supabase } from "./supabase";

export class AdminApiError extends Error {
  constructor(readonly code: string, readonly status: number) {
    super(code);
    this.name = "AdminApiError";
  }
}

export async function adminApi<T>(action: string, payload: Record<string, unknown> = {}): Promise<T> {
  const { data: sessionData, error: sessionError } = await supabase.auth.getSession();
  if (sessionError) throw sessionError;
  if (!sessionData.session) throw new AdminApiError("authentication_required", 401);
  const env = getEnv();
  const result = await fetch(`${env.supabaseUrl}/functions/v1/admin-api`, {
    method: "POST",
    headers: {
      apikey: env.publishableKey,
      Authorization: `Bearer ${sessionData.session.access_token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ action, payload }),
  });
  const body = (await result.json().catch(() => ({}))) as { data?: T; error?: string };
  if (!result.ok || body.error) throw new AdminApiError(body.error || "admin_api_failed", result.status);
  return body.data as T;
}

export const apiKeys = {
  dashboard: ["admin", "dashboard"] as const,
  users: (page: number, search: string) => ["admin", "users", page, search] as const,
  admins: ["admin", "admins"] as const,
  procurement: ["admin", "procurement"] as const,
  purchaseDetail: (requestId: string) => ["admin", "purchase-detail", requestId] as const,
  partnerImports: ["admin", "partner-imports"] as const,
  finance: ["admin", "finance"] as const,
  platformCommerceSettings: ["admin", "platform-commerce-settings"] as const,
  liveChats: (search: string, status: string) => ["admin", "live-chats", search, status] as const,
  liveChat: (conversationId: string) => ["admin", "live-chat", conversationId] as const,
  resource: (resource: string, page: number, search: string, status: string) =>
    ["admin", "resource", resource, page, search, status] as const,
};
